"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 17.5069C24.5855 17.5069 24.1881 17.6716 23.895 17.9646C23.602 18.2576 23.4374 18.655 23.4374 19.0694V28.5486C23.4374 28.963 23.602 29.3604 23.895 29.6535C24.1881 29.9465 24.5855 30.1111 24.9999 30.1111C25.4143 30.1111 25.8117 29.9465 26.1047 29.6535C26.3978 29.3604 26.5624 28.963 26.5624 28.5486V19.0694C26.5624 18.655 26.3978 18.2576 26.1047 17.9646C25.8117 17.6716 25.4143 17.5069 24.9999 17.5069Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 33.0278C24.695 33.0278 24.3969 33.1182 24.1434 33.2876C23.8899 33.457 23.6923 33.6978 23.5756 33.9795C23.4589 34.2612 23.4284 34.5712 23.4879 34.8702C23.5473 35.1693 23.6942 35.444 23.9098 35.6596C24.1254 35.8752 24.4001 36.022 24.6991 36.0815C24.9982 36.141 25.3082 36.1104 25.5899 35.9938C25.8716 35.8771 26.1124 35.6795 26.2818 35.4259C26.4512 35.1724 26.5416 34.8744 26.5416 34.5694C26.5416 34.1606 26.3791 33.7684 26.09 33.4793C25.8009 33.1902 25.4088 33.0278 24.9999 33.0278Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.7499 37.0486L28.604 9.02776C28.2378 8.39635 27.7121 7.87224 27.0795 7.50791C26.447 7.14358 25.7298 6.95181 24.9999 6.95181C24.2699 6.95181 23.5528 7.14358 22.9202 7.50791C22.2877 7.87224 21.762 8.39635 21.3957 9.02776L5.24988 37.0486C4.88436 37.6817 4.69184 38.3998 4.69165 39.1309C4.69146 39.8619 4.88361 40.5801 5.24881 41.2134C5.61401 41.8467 6.13939 42.3728 6.77221 42.7388C7.40503 43.1048 8.12301 43.2979 8.85405 43.2986H41.1457C41.8768 43.2979 42.5947 43.1048 43.2276 42.7388C43.8604 42.3728 44.3858 41.8467 44.7509 41.2134C45.1161 40.5801 45.3083 39.8619 45.3081 39.1309C45.3079 38.3998 45.1154 37.6817 44.7499 37.0486ZM42.0415 39.6528C41.954 39.8131 41.8243 39.9465 41.6664 40.0383C41.5084 40.1301 41.3284 40.1769 41.1457 40.1736H8.85405C8.6714 40.1769 8.49133 40.1301 8.3334 40.0383C8.17548 39.9465 8.04572 39.8131 7.95821 39.6528C7.85777 39.4976 7.80433 39.3168 7.80433 39.1319C7.80433 38.9471 7.85777 38.7662 7.95821 38.6111L24.104 10.6528C24.1919 10.4919 24.3215 10.3577 24.4791 10.2642C24.6367 10.1707 24.8166 10.1214 24.9999 10.1214C25.1831 10.1214 25.363 10.1707 25.5207 10.2642C25.6783 10.3577 25.8078 10.4919 25.8957 10.6528L42.0415 38.6111C42.142 38.7662 42.1954 38.9471 42.1954 39.1319C42.1954 39.3168 42.142 39.4976 42.0415 39.6528Z",
    fill: fill
  }));
};

exports["default"] = _default;